export function buildSerRate (rate) {
    return {
        id: rate.id,
        name: rate.name,
    }
}
